import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Button, Header, Paragraph } from "../../components/RegularComponents";
import { setCompanyRjscDetails } from "../../redux/slice/rjscDetailReviewSlice";

// import styles from './mra.module.scss';

const MraRJSCCompanyDetail = (props) => {
  const dispatch = useDispatch();

  const { isModal = false, onEditSave = () => {} } = props;

  const [rjscCompanyDetail, setRjscCompanyDetail] = useState("");
  const [rjscOtherCompanyDetail, setRjscOtherCompanyDetail] = useState("");

  const companyRjscDetails = useSelector(
    (state) =>
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails ?? {}
  );

  const style = {
    otherStep: {
      backgroundColor: "white",
      borderStyle: "none",
      borderWidth: "1px",
      color: "black",
      left: "-19px",
    },
  };

  const isShowError = () => {
    return null;
    //   searchStatus === REQUEST_STATUS.ERROR ||
    //   showNoResultError ||
    //   showNoStringError
  };

  const handleNext = () => {
    const updatedCompanyRJSCData = {
      authorized: false,
      businessContact: {
        civicAddress: {
          city: "",
          postalCode: "",
          province: "",
          street: "",
        },
        email: null,
        fax: null,
        mailingAddress: {
          city: "",
          postalCode: "",
          province: "",
          street: "",
        },
        phoneNumber: null,
      },
      businessData: {
        businessOwner: "",
        companyType: "Business Name",
        companyTypeId: null,
        expiryDate: "",
        peopleList: [],
        phoneNumber: null,
        relatedTo: "",
      },
      businessEntity: {
        businessName: "",
        entityId: "",
        registryNumber: "",
      },
      order: 0,
      notRegistered: rjscOtherCompanyDetail
        ? rjscOtherCompanyDetail
        : rjscCompanyDetail,
    };

    dispatch(
      setCompanyRjscDetails({
        ...companyRjscDetails,
        ...updatedCompanyRJSCData,
      })
    );

    dispatch(
      !isModal
        ? push({
            pathname: `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_COMPANY_INFO}`,
          })
        : onEditSave()
    );
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-9">
              <Header
                id="mra-company-detail-header"
                header="Business not registered with the Nova Scotia Registry of joint Stock Companies (RJSC)"
              />
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-xs-12 col-lg-9">
          <Paragraph
            id="mra-find-business-para"
            text={[
              "<b>Provide a reason why your company is not registered with RJSC</b>",
            ]}
          />
        </div>
      </div>

      <div className={"row"}>
        <div className={"col-9"}>
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--large"}>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"NB Exempt"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-MraRJSCCompanyDetail-NBExmpt-input"}
                  name={"rjsc-MraRJSCCompanyDetail-input"}
                />
                <label
                  id={"rjsc-MraRJSCCompanyDetail-NBExmpt-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-MraRJSCCompanyDetail-NBExmpt-input"}
                >
                  <span className="ns-label-span">
                    My company is registered in New Brunswick and is exempt from
                    registering in Nova Scotia
                  </span>
                </label>
              </div>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"soleProprietor"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-MraRJSCCompanyDetail-SoleProprietor-input"}
                  name={"rjsc-MraRJSCCompanyDetail-input"}
                />
                <label
                  id={"rjsc-MraRJSCCompanyDetail-SoleProprietor-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-MraRJSCCompanyDetail-SoleProprietor-input"}
                >
                  <span className="ns-label-span">
                    I am a sole proprietor operating under my own name
                  </span>
                </label>
              </div>

              <div
                style={{ marginLeft: "-55px", marginTop: "-10px" }}
                className="timeline ns-radios__item row"
              >
                <ol>
                  <li className="timeline-item col-md-12">
                    <div className="step-content col-md-12">
                      <span style={style.otherStep} className="step-counter">
                        <input
                          className="ns-radios__input"
                          type={"radio"}
                          value={"Other"}
                          onChange={(e) => setRjscCompanyDetail(e.target.value)}
                          id={"rjsc-MraRJSCCompanyDetail-SoleProprietor-input"}
                          name={"rjsc-MraRJSCCompanyDetail-input"}
                        />

                        <label
                          id={"rjsc-MraRJSCCompanyDetail-SoleProprietor-label"}
                          style={{ marginLeft: "25px", marginTop: "-10px" }}
                          className="ns-radios__label"
                          htmlFor={
                            "rjsc-MraRJSCCompanyDetail-SoleProprietor-input"
                          }
                        >
                          <span className="ns-label-span">Other</span>
                        </label>
                      </span>

                      <div className="row">
                        <div
                          style={{ marginTop: "50px", marginLeft: "-20px" }}
                          className="col-xs-12"
                        >
                          <label
                            id={"rjsc-company-other-text-label"}
                            htmlFor={"rjsc-company-other-text"}
                          >
                            <span className="ns-label-span">
                              Provide Details
                            </span>
                          </label>
                          <input
                            id="rjsc-company-other-text"
                            name="rjsc-company-other-text"
                            className="form-control ns-input fw-20"
                            type="text"
                            value={rjscOtherCompanyDetail}
                            onInput={(e) => {
                              setRjscOtherCompanyDetail(e.target.value);
                            }}
                            style={{ display: "inline" }}
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 topMarginNormal">
          <div className="has-error">
            <div className="col-lg-2 help-block">
              <Button
                id="rjsc-search-button"
                text={!isModal ? "Next" : "Save and close"}
                buttonType={"regular_primary"}
                onClick={handleNext}
              />
              {isShowError() && (
                <span style={{ marginLeft: "5px" }}>
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MraRJSCCompanyDetail;
